import { IDexTrade } from '@kattana-io/common';
import { formatTimestamp, formatTimestampTime, toFixed4 } from '../components/DexTrades/formatters';

const calcDexTrades = (trades: any, base_decimals: number, quote_decimals: number, flipped: boolean, byBlock: any, byWallet: any) => {

  /**
  * Reduces complexity by checking trades only in the same block
  * @param trade
  * @returns
  */
  const sameBlockBotComparator = (trade: any): boolean => {
    const tradesInSameBlock = byBlock[trade.blocknumber];
    if (tradesInSameBlock) {
      const inputAmount = Number(trade.amountIn);
      return !!tradesInSameBlock.find(
        (item: any) =>
          item.amountIn === inputAmount && item.buy !== trade.buy && item.wallet === trade.wallet
      );
    }
    return false;
  };

  /**
  * Get first trade in the same block
  * @param trade
  * @returns
  */
  const getSandwichAmount = (trade: IDexTrade): number => {
    const tradesInSameBlock = byBlock[trade.blocknumber];
    const sellTrade = tradesInSameBlock.find(
      (item: IDexTrade) =>
        +item.amount0 === +trade.amount0 && !item.buy && item.wallet === trade.wallet
    );
    const buyTrade = tradesInSameBlock.find(
      (item: IDexTrade) =>
        +item.amount0 === +trade.amount0 && item.buy && item.wallet === trade.wallet
    );
    return (parseInt(sellTrade.amount1) - parseInt(buyTrade.amount1)) / 10 ** quote_decimals;
  };


  return trades.map((trade: any) => {
    const numericIn = toFixed4(Number(trade.amount0) / 10 ** base_decimals);
    const numericOut = toFixed4(Number(trade.amount1) / 10 ** quote_decimals);

    const sandwich = (trade.bot === 1 && sameBlockBotComparator(trade)) || false;
    const sandwichAmount = sandwich ? getSandwichAmount(trade) : 0;

    let price: number;
    let priceUSD: number;
    if (flipped) {
      price = Number(trade.price_b);
      priceUSD = trade.price_b_usd;
    } else {
      price = Number(trade.price_a);
      priceUSD = trade.price_a_usd;
    }

    return ({
      uuid: `${trade.tx}-${trade.order}`,
      date: formatTimestamp(trade.timestamp),
      dateShort: formatTimestampTime(trade.timestamp),
      timestamp: trade.timestamp,
      side: trade.buy === 1 ? 'Buy' : 'Sell',
      priceUSD: priceUSD,
      price: price,
      numericIn: Number(numericIn),
      numericOut: Number(numericOut),
      bot: trade.bot,
      txValue: trade.value_usd,
      tx: trade.tx,
      txString:
          trade.tx.slice(0, 4) +
          '...' +
          trade.tx.slice(trade.tx.length - 4, trade.tx.length),
      sandwich,
      sandwichAmount,
      tradesWithThisWallet: byWallet[trade.wallet] || [],
      wallet: trade.wallet,
      blocknumber: trade.blocknumber,
    });
  });
};

const fillHashesFromData = (data: any[], byBlock: any, byWallet: any) => {

  const blockHashes = byBlock;
  const walletHashes = byWallet;

  data?.forEach((trade: any) => {
    const blockCollection = blockHashes[trade.blocknumber];
    const walletCollection = walletHashes[trade.wallet];

    const { buy, wallet } = trade;
    if (blockCollection) {
      blockHashes[trade.blocknumber].push({
        amount0: Number(trade.amount0),
        amount1: Number(trade.amount1),
        buy,
        wallet
      });
    } else {
      blockHashes[trade.blocknumber] = [{
        amount0: Number(trade.amount0),
        amount1: Number(trade.amount1),
        buy,
        wallet
      }];
    }

    if (walletCollection) {
      if(!walletHashes[trade.wallet].some((i: any) => i.tx === trade.tx)){ // to prevent from pushing already pushed trades
        walletHashes[trade.wallet].push(trade);
      }
    } else {
      walletHashes[trade.wallet] = [trade];
    }
  });

  return {
    byWallet: walletHashes,
    byBlock: blockHashes
  };
};

export { calcDexTrades, fillHashesFromData };
